import { fetch_app_data, mount_vue_app, read_app_config } from '../_partials/_app.js';
import App from '../jobs-app/app.vue';

(function () {
	const button_el = document.getElementById(`js-read-more`);
	if (!button_el) {
		return;
	}

	function on_click() {
		button_el.parentNode.removeChild(button_el);
	}

	button_el.addEventListener(`click`, on_click);
})();

(function () {
	const app_el = document.getElementById(`js-jobs-app`);
	if (!app_el) {
		return;
	}

	const config = read_app_config(app_el);

	mount_vue_app(app_el, async () => {
		const data = await fetch_app_data(config.api_url, `/api/store`);

		return {
			component: App,
			store: {
				...data,
				...config,
				defaults: {
					...data.defaults,
					...config.defaults,
				},
			},
		};
	});
})();
